import { Component, ViewChild } from "@angular/core";
import { BaseClass } from "src/app/shared/classes/base";
import { AutoSaveComponent } from "src/app/shared/components/autosave/autosave.component";
import { ProcessConfig, QuestionConfig, QuestionConfigTypeEnum, QuestionGroup, QuestionTypeEnum } from "src/app/shared/interfaces/process-config.interface";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ManagedUser } from "src/app/manager-evaluation/_interfaces/managed-user.interface";
import { AlertController, LoadingController, ModalController, ToastController } from "@ionic/angular";
import { TranslationService } from "src/app/shared/services/translation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UtilService } from "src/app/shared/services/util.service";
import { QuestionGroupAttributesPipe } from "src/app/shared/pipes/question-group-attributes.pipe";
import { QuestionAttributePipe } from "src/app/shared/pipes/question-attribute.pipe";
import { environment } from "src/environments/environment";
import { SelfEvaluationRecord } from "src/app/self-evaluation/_interfaces/self-evaluation-record.interface";
import { FinalFeedbackService } from "src/app/final-feedback/final-feedback.service";
import { FinalFeedback, FinalFeedbackStatus } from "src/app/final-feedback/interfaces/final-feedback.interface";
import { debounceTime, distinctUntilChanged, pairwise, startWith } from "rxjs/operators";
import { UserPreview } from "src/app/shared/interfaces/user-preview.interface";
import { ReviewEvaluationsModal } from "src/app/shared/components/review-evaluations/review-evaluations.modal";
import { PerformanceCycleService } from "src/app/performance-cycles/performance-cycles.service";
import { ProcessesService } from "src/app/processes/processes.service";
import { ProcessTypeEnum } from "src/app/shared/interfaces/process.interface";
import { ConfigService } from "src/app/shared/services/multi-clients/config.service";

@Component({
    selector: "app-final-feedback-review",
    templateUrl: "./final-feedback-review.page.html",
    styleUrls: ["./final-feedback-review.page.scss"],
})
export class FinalFeedbackReviewPage extends BaseClass {
    @ViewChild("autosave", { static: true }) autosave: AutoSaveComponent;
    public hideQuestionNumber: boolean = environment.features.hideQuestionNumber;
    public questionsType;
    public onlyFinalFeedbackSeeReviews: boolean = false;
    public processConfig: ProcessConfig;
    public allQuestions: Array<QuestionConfig> = [];
    public formGroup: UntypedFormGroup;
    public user: UserPreview;
    public subordinateAnswers: SelfEvaluationRecord;
    public status: FinalFeedbackStatus;

    public allowAutoSave: boolean = true;
    public isSaving = false;
    public timerStart: boolean = false;
    public autoSaving: boolean = false;
    public hasPendingChanges: boolean = false;
    public canEdit = false;
    public timerId;

    private _returnPath: string = undefined;
    private readonly _cycleId: number;
    private readonly _cycleProcessConfigId: number;
    private _participantId: number;
    private readonly _userId: string;
    public selectedLanguage: string;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        public alertController: AlertController,
        private _loadingController: LoadingController,
        private _cycleService: PerformanceCycleService,
        private _router: Router,
        private _finalFeedbackService: FinalFeedbackService,
        private _activatedRoute: ActivatedRoute,
        private _utilService: UtilService,
        private _questionGroupsAttributePipe: QuestionGroupAttributesPipe,
        private _questionAttributePipe: QuestionAttributePipe,
        private _modalController: ModalController,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
        this._cycleId = parseInt(this._activatedRoute.snapshot.paramMap.get("cycleId"), 10);
        this._cycleProcessConfigId = parseInt(this._activatedRoute.snapshot.paramMap.get("cycleProcessConfigId"), 10);
        this._userId = this._activatedRoute.snapshot.paramMap.get("userId");
        this.questionsType = this._configService.settings.features.questionTypeAvailability.question;
    }

    ionViewWillEnter() {
        this.selectedLanguage = this._translationService.getSelectedLanguage();
        this._loadFinalFeedback(this._cycleId, this._cycleProcessConfigId);
        this._loadCycleConfig(this._cycleId)
    }

    public goBack(): void {
        this._returnPath = localStorage.getItem("FinalFeedbackReview_ReturnPath");
        this._router.navigate([this._returnPath ? this._returnPath : "dashboard"]);
    }

    public goToNotepad(): void {
        this._setReturnPath("Notepad_ReturnPath");
        this._router.navigate(["notepad"]);
    }

    public async viewReviews(): Promise<void> {
        console.log(this._cycleId, this._userId

        )
        const modal = await this._modalController.create({
            component: ReviewEvaluationsModal,
            cssClass: "new-goals-input round bigger-modal",
            componentProps: {
                cycleId: this._cycleId,
                userId: this._userId,
            },
        });

        return await modal.present();
    }

    private _setReturnPath(storageKey: string): void {
        localStorage.setItem(storageKey, "final-feedback-validation/" + this._cycleId + "/" + this._cycleProcessConfigId + "/" + this._userId);
    }

    public async save(formGroup: UntypedFormGroup, send: boolean = false, showSuccessNotify: boolean = true): Promise<void> {
        this._saveEvaluation(formGroup, send, showSuccessNotify);
    }

    private _saveEvaluation(formGroup: UntypedFormGroup, send: boolean, showSuccessNotify = true): void {
        this.autoSaving = true;
        this.timerStart = false;
        clearTimeout(this.timerId);

        const evaluation = this._utilService.adjustRatingsForGoals(this.processConfig.questionsGroups, formGroup.getRawValue()) as FinalFeedback;

        this.isSaving = true;
        this._finalFeedbackService.saveFinalFeedbackReview(evaluation).subscribe(
            () => {
                if (send) {
                    if (!formGroup.valid) {
                        this.notify(this._translationService.getTranslation("generic.requiredValueNotProvided"), "danger");
                        this.autoSaving = false;
                        return;
                    }
                    this._finalFeedbackService.finishFinalFeedback(this._participantId, this._cycleProcessConfigId).subscribe(() => {
                        if (showSuccessNotify) {
                            this.hasPendingChanges = false;
                            this.notifySuccess();
                        }

                        this.goBack();
                    });
                } else {
                    if (showSuccessNotify) {
                        this.hasPendingChanges = false;
                        this.notifySuccess();
                    }

                    this.autoSaving = false;
                }
            },
            (error) => {
                this.notifyError(error);
                this.autoSaving = false;
            },
            () => (this.isSaving = false),
        );
    }

    private async _loadCycleConfig(cycleId: number): Promise<void> {
    this._cycleService.getCycleById(cycleId).subscribe(
        async (response) => {
            const foundProcess = response.data.processes.find(p =>
                p.type === ProcessTypeEnum.FinalFeedback && p.onlyFinalFeedbackSeeReviews === true
            );
            this.onlyFinalFeedbackSeeReviews = !!foundProcess;
        },
        (error) => this.notifyError(error)
    );
}


    private async _loadFinalFeedback(cycleId: number, cycleProcessConfigId: number): Promise<void> {
        const loading = await this._loadingController.create();
        await loading.present();

        this._finalFeedbackService.getSubordinateFinalFeedback(cycleProcessConfigId, this._userId, this._cycleId).subscribe(
            async (response) => {
                this._participantId = response.data.cycleParticipantId;
                this.status = response.data.status;
                this.subordinateAnswers = response.data.subordinateFinalFeedback;

                this.canEdit = this.status === FinalFeedbackStatus.Draft || this.status === FinalFeedbackStatus.AwaitingAuthorization;

                this.processConfig = response.data.config;
                if (this.processConfig.questions) {
                    this.allQuestions = [...this.allQuestions, ...this.processConfig.questions];
                } else {
                    let questions: QuestionConfig[] = [];
                    this.processConfig.questionsGroups.forEach((group) => {
                        questions = [...questions, ...group.questions];
                        questions = this._questionAttributePipe.transform(questions, response.data.user.attributes);
                    });
                    this.allQuestions = [...this.allQuestions, ...questions];
                }

                this.user = response.data.user;
                this.processConfig.questionsGroups = this.processConfig.questionsGroups.sort((a, b) => a.order - b.order);
                const formGroup = this._createFormGroup(this.processConfig.questionsGroups, response.data.finalFeedback);

                if (this.processConfig.questionsGroups) {
                    this.processConfig.questionsGroups.forEach((group) => {
                        group.questions = this._utilService.groupQuestions(group.questions);
                        group.hasCalculateQuestions = this.hasCalculateType(group);
                    });
                }

                this.formGroup = formGroup;

                if (this.autosave) {
                    this.autosave.autoSaveAllowed$.subscribe((value: boolean) => {
                        this.allowAutoSave = value;
                    });
                }

                this.formGroup.valueChanges.pipe(startWith(this.formGroup.value), distinctUntilChanged(), pairwise()).subscribe(async ([previous, current]) => {
                    if (JSON.stringify(previous) === JSON.stringify(current)) return;
                    this.allowAutoSave = false;
                    const valuesToSet = await this._utilService.calculateRelatedQuestions(current, this.allQuestions, previous);
                    valuesToSet.forEach((result) => {
                        this.formGroup.get(result.field).setValue(result.value, { emitEvent: true, onlySelf: true });
                    });
                    this.allowAutoSave = true;
                });

                this.formGroup.valueChanges.pipe(distinctUntilChanged(), debounceTime(15000)).subscribe((evaluation) => {
                    if (this.allowAutoSave && !this.timerStart) {
                        this.timerStart = true;
                        this._autoSave();
                    }
                });

                await loading.dismiss();
            },
            (error) => {
                loading.dismiss();
                this.notify(this.getErrorNotification(error), "danger");
            },
        );
    }

    private hasCalculateType(group: QuestionGroup) {
        return group.questions.some((q) => q.typeConfig.type === QuestionTypeEnum.Calculate);
    }

    private _autoSave() {
        this.timerStart = false;
        this.hasPendingChanges = this.autoSaving && true;

        if (!this.autoSaving && this.status !== FinalFeedbackStatus.Authorized) {
            this._saveEvaluation(this.formGroup, false);
        }
    }

    private _createFormGroup(groups: Array<QuestionGroup>, editingEvaluation: FinalFeedback): UntypedFormGroup {
        const formGroup = new UntypedFormGroup({
            cycleId: new UntypedFormControl(this._cycleId),
            cycleParticipantId: new UntypedFormControl(this._participantId),
            cycleProcessConfigId: new UntypedFormControl(this._cycleProcessConfigId),
        });

        const goalsIndexes = this._utilService.getGoalsFieldsIndexes(groups);
        let currentIndex = 1;

        if (groups) {
            const displayedGroups = this._questionGroupsAttributePipe.transform(groups, this.user.attributes);

            groups.forEach((group) => {
                group.questions.forEach((question) => {
                    const controlName = "field" + currentIndex;
                    const validators =
                        displayedGroups.some((g) => g.id === group.id) && (question.required || question.goal) && question.hideQuestion !== true ? [Validators.required] : [];

                    formGroup.addControl(
                        controlName,
                        new UntypedFormControl(
                            {
                                value: this._utilService.getEvaluationValue(question, editingEvaluation, goalsIndexes, currentIndex),
                                disabled: this.status === FinalFeedbackStatus.Authorized,
                            },
                            validators,
                        ),
                    );

                    question.currentIndex = currentIndex;
                    currentIndex++;
                });
            });
        }

        return formGroup;
    }
}
